module.exports = __webpack_public_path__ + "img/btn-banner-start-room.ff6d60ce.svg";